import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const noAuthSplitApi = createApi({
  reducerPath: "noAuthSplitApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_BACKEND_URL }),
  endpoints: () => ({}),
});
